import { useRoute } from 'vue-router'
import { ref, watch } from 'vue'
import { useLoadGeoGsonFile } from '@/features/Inventory/ObjectFileGeoGson/model/api.ts'
import { useHelpers } from '@/shared/lib'

export const useObjectGeoJson = () => {
  const route = useRoute()
  const { saveFile } = useHelpers()

  const groupId = ref(0)
  const typeId = ref(0)
  const ids = ref<number[]>([])

  const { isFetching, data, refetch } = useLoadGeoGsonFile(groupId, typeId, ids)

  /**
   * Функция получения файла с GeoJSON данными
   * @param objTypeId
   * @param objIds
   */
  const downLoadFile = (objTypeId: number, objIds: number[] = []) => {
    groupId.value = Number(route.params.object_id)
    typeId.value = objTypeId
    ids.value = objIds

    if (!groupId.value || !typeId.value) return

    refetch()
  }

  /** Отслеживаем загрузку данных и скачиваем ее */
  watch(
    () => data.value,
    () => {
      if (data.value) {
        const fileData = new Blob([data.value.data])
        saveFile(URL.createObjectURL(fileData), `geo_json_list.json`)
      }
    },
  )

  return {
    downLoadFile,
    isFetching,
  }
}
